/* L'Heureux - Product subscription selector (Recharge selling plans). */
(function () {
  var STYLE_ID = 'lhsub-styles';
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = `
.lhsub{display:block;margin:16px 0}
.lhsub__options{display:grid;grid-template-columns:1fr;gap:8px}
.lhsub__opt{position:relative;display:block;margin:0}
.lhsub__opt input{position:absolute;top:0;left:0;width:100%;height:100%;margin:0;opacity:0;cursor:pointer}
.lhsub__btn{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:6px;text-align:center;padding:11px 12px;min-height:46px;border:1px solid rgba(18,61,102,.35);border-radius:10px;font-size:14px;line-height:1.2;cursor:pointer;transition:border-color .15s ease,box-shadow .15s ease}
.lhsub__opt input:checked+.lhsub__btn{border-color:#123D66;box-shadow:inset 0 0 0 1px #123D66;font-weight:700}
.lhsub__opt input:focus-visible+.lhsub__btn{outline:2px solid #123D66;outline-offset:2px}
.lhsub__badge{background:#1b7f4b;color:#fff;border-radius:4px;padding:1px 6px;font-size:11px;font-weight:800;white-space:nowrap}
.lhsub__freq{margin-top:10px}
.lhsub__freq-label{display:block;font-size:13px;font-weight:600;margin-bottom:6px}
`;
    document.head.appendChild(s);
  }

  if (!customElements.get('subscribe-option')) {
    class SubscribeOption extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;
        injectStyles();
        try { this.data = JSON.parse(this.querySelector('.lhsub-data').textContent); }
        catch (e) { this.data = { variants: {}, plans: [] }; }
        this.isFr = (this.dataset.lang || '').slice(0, 2) === 'fr';
        this.subRadio = this.querySelector('.js-sub');
        this.freqWrap = this.querySelector('.lhsub__freq');
        this.freqSelect = this.querySelector('.lhsub-select');
        this.badgeEl = this.querySelector('.lhsub__badge');
        this._applied = false;
        this.populateFreq();
        this.addEventListener('change', this.onChange.bind(this));
        document.addEventListener('on:variant:change', this.onVariantChange.bind(this));
        this.updateBadge();
      }

      freqLabel(name) {
        var lower = (name || '').toLowerCase();
        var count = 1;
        (name || '').split(/\s+/).forEach(function (w) {
          var n = parseInt(w, 10);
          if (!isNaN(n) && n > 0) count = n;
        });
        var unit = 'week';
        if (lower.indexOf('mois') > -1 || lower.indexOf('month') > -1) unit = 'month';
        else if (lower.indexOf('jour') > -1 || lower.indexOf('day') > -1) unit = 'day';
        if (this.isFr) {
          if (unit === 'month') return count === 1 ? 'Chaque mois' : 'Chaque ' + count + ' mois';
          if (unit === 'day') return count === 1 ? 'Chaque jour' : 'Chaque ' + count + ' jours';
          return count === 1 ? 'Chaque semaine' : 'Chaque ' + count + ' semaines';
        }
        if (unit === 'month') return count === 1 ? 'Every month' : 'Every ' + count + ' months';
        if (unit === 'day') return count === 1 ? 'Every day' : 'Every ' + count + ' days';
        return count === 1 ? 'Every week' : 'Every ' + count + ' weeks';
      }

      populateFreq() {
        if (!this.freqSelect) return;
        var self = this;
        this.freqSelect.innerHTML = this.data.plans.map(function (p) {
          return '<option value="' + p.id + '">' + self.freqLabel(p.name) + '</option>';
        }).join('');
      }

      getRoot() {
        return this.closest('quick-add-drawer') || this.closest('.shopify-section') || document;
      }

      getForm() {
        var root = this.getRoot();
        return root.querySelector('product-form form') || root.querySelector('form[action*="/cart/add"]');
      }

      getPriceEl() {
        return this.getRoot().querySelector('.price');
      }

      getVariantId() {
        var form = this.getForm();
        var idInput = form && form.querySelector('[name="id"]');
        if (idInput && idInput.value) return String(idInput.value);
        var keys = Object.keys(this.data.variants);
        return keys.length ? keys[0] : null;
      }

      setPlan(planId) {
        var form = this.getForm();
        if (!form) return;
        var input = form.querySelector('input.lhsub-input');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          input.className = 'lhsub-input';
          form.appendChild(input);
        }
        if (planId) { input.disabled = false; input.value = planId; }
        else { input.disabled = true; input.value = ''; }
      }

      onChange(evt) {
        if (evt.target.classList.contains('lhsub-type')) {
          if (this.subRadio && this.subRadio.checked) {
            if (this.freqWrap) this.freqWrap.hidden = false;
            this.setPlan(this.freqSelect ? this.freqSelect.value : null);
          } else {
            if (this.freqWrap) this.freqWrap.hidden = true;
            this.setPlan(null);
          }
          this.updatePrice();
        } else if (evt.target === this.freqSelect && this.subRadio && this.subRadio.checked) {
          this.setPlan(this.freqSelect.value);
          this.updatePrice();
        }
      }

      onVariantChange() {
        this._applied = false;
        var self = this;
        setTimeout(function () {
          self.updateBadge();
          self.updatePrice();
          if (self.subRadio && self.subRadio.checked && self.freqSelect) self.setPlan(self.freqSelect.value);
        }, 40);
      }

      updateBadge() {
        if (!this.badgeEl) return;
        var v = this.data.variants[this.getVariantId()];
        var first = this.data.plans[0];
        if (v && first && v.plans[first.id] && v.plans[first.id].c != null && v.c > 0) {
          var pct = Math.round((v.c - v.plans[first.id].c) / v.c * 100);
          if (pct > 0) { this.badgeEl.textContent = '-' + pct + '%'; this.badgeEl.hidden = false; return; }
        }
        this.badgeEl.hidden = true;
      }

      updatePrice() {
        var priceEl = this.getPriceEl();
        if (!priceEl) return;
        var cur = priceEl.querySelector('.price__current .js-value');
        var was = priceEl.querySelector('.price__was .js-value');
        if (!cur) return;
        var v = this.data.variants[this.getVariantId()];
        if (!v) return;
        var subActive = this.subRadio && this.subRadio.checked;
        var pid = this.freqSelect ? this.freqSelect.value : null;
        var plan = (subActive && pid) ? v.plans[pid] : null;
        if (subActive && plan && plan.c != null && plan.c < v.c) {
          if (!this._applied) {
            this._snapCur = cur.innerHTML;
            this._snapWas = was ? was.innerHTML : '';
            this._snapSale = priceEl.classList.contains('price--on-sale');
            this._applied = true;
          }
          cur.innerHTML = plan.s;
          if (was) was.innerHTML = v.s;
          priceEl.classList.add('price--on-sale');
        } else if (this._applied) {
          cur.innerHTML = this._snapCur;
          if (was) was.innerHTML = this._snapWas;
          if (this._snapSale) priceEl.classList.add('price--on-sale');
          else priceEl.classList.remove('price--on-sale');
          this._applied = false;
        }
      }
    }
    customElements.define('subscribe-option', SubscribeOption);
  }
})();
